import endpoints from "@config/endpoints";
import axios from "@utils/axiosExt";
import Auth from "./auth";
const isUsingGramPanchayatUtils=async (stateCode:any)=>{
    try{
        const stateSpecificRes=await axios.get(`${endpoints.getStateSpecific}/${stateCode}`, Auth.loggedIn())
        const stateSpecificData=stateSpecificRes?.data?.data[0];
        return stateSpecificData?.stateCode===stateCode?.toString() && stateSpecificData.isUsingGramPanchayat ?true:false;
    }
    catch(error:any){
        return false;
    }
}
export default isUsingGramPanchayatUtils;